import React, { Component } from 'react';
import classNames from 'classnames';

import withModifierDetails from './WithModifierDetails';
import { getActiveModifierOption } from '../../global/ProductHelpers';

class Buttons extends Component {
  render(activeOption) {
    const {
      modifier: {
        options = [],
      },
    } = this.props;

    return (
      <div className="pdp-options-ul pdp-options-ul--wrapped">
        {options.map((option) => {
          const {
            value,
            colors,
            label,
          } = option;

          const color = colors?.length > 0 ? colors[0].hex : '';

          const active = getActiveModifierOption(activeOption, value);

          return (
            <div
              role="button"
              key={option.value}
              onClick={() => this.selectModifierOption(option)}
              className={classNames(value, 'pdp-options-button', {
                active,
                'pdp-options-button__left-aligned': color,
              })}
            >
              {color && <span className="pdp-options-button__color" style={{ backgroundColor: color, color }}>i</span>}
              <span className="title">{label}</span>
            </div>
          );
        })}
      </div>
    );
  }
}

const ButtonsModifier = withModifierDetails(Buttons);

export default ButtonsModifier;
